import "animate.css/animate.compat.css";
import "animate.css";
import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import { profileRoutes, routes } from "./routes/routes";
import ProtectedRoute from "./views/ProtectedRoute";
import NotFound from "./views/NotFound/NotFound";
import Dashboard from "./views/Dashboard/Dashboard";
import { AppProvider } from "@toolpad/core/AppProvider";
import { demoTheme, NAVIGATION } from "./components/SideBar/SidebarAdmin";
import { useToolpadRouter } from "./hooks/toolpadRouter";
import IconRadaria from "./assets/icons/RADARIA-LOGOTIPO01.png";
import useCheckSession from "./hooks/useCheckSession";

function App() {
  const { isAuthenticated } = useSelector((state) => state.authReducer);
  const router = useToolpadRouter();
  useCheckSession();
  return (
    <AppProvider
      navigation={NAVIGATION}
      router={router}
      branding={{
        logo: <img src={IconRadaria} alt="Mi Logo" width={150} />,
        title: "",
        homeUrl: "",
      }}
      theme={demoTheme}
    >
      <Routes>
        {routes.map((page, index) => (
          <Route {...page} key={index} />
        ))}
        <Route element={<ProtectedRoute isAuthenticated={isAuthenticated} />}>
          <Route path="/dashboard" element={<Dashboard />}>
            {profileRoutes.map((page, index) => (
              <Route {...page} key={index} />
            ))}
          </Route>
        </Route>
        <Route path="*" Component={NotFound} />
      </Routes>
    </AppProvider>
  );
}

export default App;
